var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"resumo-step"}},[_c('visualizar-dados-pessoa',{attrs:{"pessoa":_vm.registroResource.solicitante}}),_c('visualizar-info-complementares',{attrs:{"info":_vm.registroResource.informacoesComplementares}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }